require("Utils/object_extensions.exec.js");
import {
  geo_aggregations_column_lookup,
  geo_aggregation_value_column_lookup,
  boundaries_lookup,
  community_aggregation_lookup,
  community_table_suffixes_lookup,
  community_columns_lookup,
  community_columns_lookup_v2,
  community_table_prefixes_lookup
} from "Lookups";

import config from "Config";
/*
 * based on state.domain_data this function computes a number of strings that can be
 * substituted in sql queries.
 */
/**
 * @param  {object} params
 * @param  {string} params.year
 * @param  {string} params.community
 * @param  {string} params.community_value
 * @param  {string} params.geo_aggregation
 * @param  {string} params.geo_aggregation_value
 */
const computeSqlParams = ({
  year,
  community,
  community_value,
  geo_aggregation,
  geo_aggregation_value
}) =>
  ({
    community_table: compute_community_table(year, geo_aggregation, community),
    community_column: community_columns_lookup[community],
    community_aggregation_value_column: community_columns_lookup_v2[community], // seems we have new colum called `dlgc_cat` currently used by COMPARISON_COMMUNITY queries. its hard coded in `optionally_reduce_community_aggregation_value` right now. 
    // TODO: probably need to stop hard coding `dlgc_cat` column and use the lookup (clarify with @cesar).
    geo_aggregation_column: geo_aggregations_column_lookup(
      year,
      geo_aggregation
    ),
    boundary_table: boundaries_lookup(year, geo_aggregation),
    geo_aggregation_value_column: geo_aggregation_value_column_lookup(
      year,
      geo_aggregation
    ),
    interactivity: compute_interactivity(
      year,
      geo_aggregation,
      community_value
    ),
    join_statement: compute_join_values(geo_aggregation, year),
    community_aggregation: community_aggregation_lookup[community],
    geo_aggregation: geo_aggregation_value ? geo_aggregation : "ste",
    map_geo_aggregation: geo_aggregation,
    year,
    community,
    community_value,
    geo_aggregation_value
  }.chain(params => ({
    optionally_reduce_geo_aggregation_value:
      params.geo_aggregation != "ste" && params.geo_aggregation_value
        ? `WHERE ${params.geo_aggregation_value_column} = $$${params.geo_aggregation_value}$$`
        : "WHERE 1 = 1",
    optionally_reduce_community_aggregation_value: params.community_value
      ? `WHERE dlgc_cat = $$${params.community_value}$$`
      : "WHERE 1 = 1",
    ...params
  })));

export default computeSqlParams;

const compute_community_table = (year, geo_aggregation, community) =>
  community_table_prefixes_lookup(year, geo_aggregation.toLowerCase()) +
  community_table_suffixes_lookup[community];

const compute_interactivity = (year, geo_aggregation, community_value) =>
  [
    geo_aggregations_column_lookup(year, geo_aggregation),
    community_value ? "number" : null
  ]
    .filter(x => x)
    .join(", ");

const compute_join_values = (geo_aggregation, year) =>
  ({
    lga: [
      `local_government_areas_${year}_boundaries_ur`,
      `lga_name${config.lga_boundary_year[year]}`
    ],
    sed: [
      "state_electoral_divisions_ur",
      `sed_name${
        config.cartodb_username === "dlgrma"
          ? config.sed_boundary_year[year]
          : ""
      }` // TODO: fix after this closed https://github.com/geografia-au/J0259-dlgrma_pipeline/issues/10
    ] //TODO: fix for https://github.com/geografia-au/dlgrma/issues/15#issuecomment-515109470 should be renamed after and
    // for https://github.com/geografia-au/dlgrma/issues/15#issuecomment-515111997
  }.chain(join_values =>
    join_values[geo_aggregation]
      ? join_values[geo_aggregation].chain(
          ([one, two]) => `AND community.${one} = bounds.${two}`
        )
      : ""
  ));



// WEBPACK FOOTER //
// ./services/sqlQueryParams.js